import React from "react";
import { IoSearchOutline } from "react-icons/io5";
import Nodata from "../Atoms/NoData/NoData";
import DateRangePicker from "../Atoms/DateRangePicker/DateRangePicker";
import CustomSelect from "../Atoms/Select/CustomSelect";
import Select from "react-select";
import DualDatePicker from "../Atoms/DateRangePicker/DualDatePicker";
import { capitalizeWords } from "../../_helpers";

const NewTable = ({
  Heading,
  tableHeadings = [],
  showExtraHeading,
  data,
  searchTerm,
  setSearchTerm,
  showSearch = true,
  placeholder,
  summaryDataFull,
  showSorting = false,
  onSortByStatus,
  sortStatusValue = "All",
  walletId,
  onAdd,
  showAddButton = false,
  addButtonText = "Fiat Collection",
  sortingOptions,
  fromDate,
  setFromDate,
  setToDate,
  handleDateRangeChange,
  toDate,
  showDateFilter = false,
  receivedTitle = "Received",
  sentTitle = "Sent",
  FeesTitle = "Fees",
  showPageTopData1,
  showPageTopData2,
  showPageTopData3,
  showPageTopData4,
  showDropDown2,
  showDropDown1,
  sortStatusValue2,
  onSortByStatus2,
  sortingOptions2,
  showFeesButton = false,
  feesButtonText = "Fees %",
  onFeesClick,
  feesClicked,
  total = false,
  count,
  isSearchAbleSelect = false,
  selectClassName2 = "",
  showDualDateFilter = false,
  dateFormat = "date",
}) => {
  return (
    <section className="w-full overflow-hidden overflow-x-auto overflow-y-auto">
      {Heading && (
        <div className="mb-4">
          <h1 className="tableHeading">{Heading} </h1>
        </div>
      )}
      {total && (
        <div>
          <div className="text-[#1D1F2C] font-[500] text-[14px]">
            Total {(count?.total ?? 0).toFixed(4)}
          </div>
        </div>
      )}
      {summaryDataFull && (
        <div className="flex gap-6 mb-2">
          <div>
            {showPageTopData1 && (
              <div className="mb-2">
                <span className="text-[#1D1F2C] font-[500] text-[14px]">
                  {sentTitle}
                </span>
                <div className="text-[#1D1F2C] font-[500] text-[14px]">
                  {" "}
                  {summaryDataFull?.sent?.amount}
                </div>
              </div>
            )}
            {showPageTopData2 && (
              <div>
                <span className="text-[#1D1F2C] font-[500] text-[14px]">
                  {receivedTitle}
                </span>
                <div className="text-[#1D1F2C] font-[500] text-[14px]">
                  {summaryDataFull.received.amount}
                </div>
              </div>
            )}
          </div>
          <div>
            {showPageTopData3 && (
              <div className="mb-2">
                <span className="text-[#1D1F2C] font-[500] text-[14px]">
                  {FeesTitle}
                </span>
                <div className="text-[#1D1F2C] font-[500] text-[14px]">
                  ({summaryDataFull.sent.fees})
                </div>
              </div>
            )}
            {showPageTopData4 && (
              <div>
                <span className="text-[#1D1F2C] font-[500] text-[14px]">
                  Fees
                </span>
                <div className="text-[#1D1F2C] font-[500] text-[14px]">
                  ({summaryDataFull.received.fees})
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      <div className="flex flex-col items-start justify-between w-full gap-4 mb-4 sm:flex-row sm:items-center">
        {showSearch && (
          <div className="w-full space-y-2">
            <div className="relative lg:w-72 w-full">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                <IoSearchOutline size={20} className="text-black" />
              </div>
              <input
                type="text"
                id="simple-search"
                className="w-full pl-10 px-4 py-2 bg-[#FFFFFF] border border-[#E0E2E7] text-black rounded-lg placeholder:text-[#858D9D]"
                placeholder={placeholder ? placeholder : "Search Here..."}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        )}

        {showSorting && (
          <div className="flex flex-col w-full gap-3 sm:flex-row sm:items-center sm:flex-wrap sm:justify-end">
            <div className="flex flex-col w-full gap-3 sm:flex-row sm:items-center sm:w-auto">
              {showDropDown1 && (
                <div className="relative w-full sm:w-48">
                  <CustomSelect
                    value={sortStatusValue}
                    options={sortingOptions}
                    onChange={onSortByStatus}
                  />
                </div>
              )}
              {showDateFilter && (
                <div className="w-full min-w-40 sm:w-full">
                  <DateRangePicker
                    startDate={fromDate}
                    setStartDate={setFromDate}
                    endDate={toDate}
                    setEndDate={setToDate}
                    onDateRangeChange={handleDateRangeChange}
                  />
                </div>
              )}
              {showDualDateFilter && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                  <DualDatePicker
                    label={capitalizeWords(`Select Start ${dateFormat}`)}
                    value={fromDate}
                    onChange={(val) => {
                      setFromDate(val);
                      handleDateRangeChange();
                    }}
                    maxDate={toDate}
                    format={dateFormat}
                  />
                  <DualDatePicker
                    label={capitalizeWords(`Select End ${dateFormat}`)}
                    value={toDate}
                    onChange={(val) => {
                      setToDate(val);
                      handleDateRangeChange();
                    }}
                    minDate={fromDate}
                    format={dateFormat}
                  />
                </div>
              )}

              {isSearchAbleSelect && (
                <div>
                  <Select
                    value={sortStatusValue}
                    onChange={onSortByStatus}
                    options={sortingOptions}
                    placeholder="Search and select..."
                    isSearchable={true}
                    className="w-full sm:w-48"
                    classNamePrefix="custom-react-select"
                  />
                </div>
              )}

              {showDropDown2 && (
                <div className="relative w-full sm:w-48">
                  <CustomSelect
                    value={sortStatusValue2}
                    options={sortingOptions2}
                    onChange={onSortByStatus2}
                    selectClassName={selectClassName2}
                  />
                </div>
              )}

              {/* Fees Button */}
              {showFeesButton && (
                <div className="w-full sm:w-auto">
                  <button
                    className={`flex items-center justify-center w-full px-4 py-2 text-sm font-medium rounded-md border border-gray-300 ${
                      feesClicked ? "bg-green-50 text-black" : "text-gray-700"
                    }`}
                    onClick={onFeesClick}
                  >
                    {feesButtonText}
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
        {/* Add Button */}
        {showAddButton && (
          <div className="">
            <button
              className="flex md:w-56 items-center justify-center w-full px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700"
              onClick={onAdd}
            >
              {addButtonText}
            </button>
          </div>
        )}
      </div>

      <div className="w-full rounded-lg">
        {data && Array.isArray(data) && data.length > 0 ? (
          <>
            <div className="hidden w-full overflow-hidden overflow-x-auto border border-[#ebedf0] rounded-lg lg:block">
              <table className="w-full text-left">
                <thead className="rounded-t-lg bg-[#F1F5F9] border-b">
                  <tr>
                    {tableHeadings.map((heading, index) => (
                      <th
                        key={index}
                        className="p-4 font-[600] text-[14px] text-left text-[#1D1F2C] whitespace-nowrap"
                      >
                        {heading}
                      </th>
                    ))}
                    {showExtraHeading &&
                      [...Array(Math.max(0, 10 - tableHeadings.length))].map(
                        (_, index) => <th key={index} className="p-3"></th>
                      )}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {data.map((row, index) => (
                    <tr
                      key={index}
                      className="transition-colors duration-200 hover:bg-gray-50"
                    >
                      {row && Array.isArray(row) && row.length > 0 ? (
                        row.map((cell, cellIndex) => (
                          <td
                            key={cellIndex}
                            className="p-4 whitespace-nowrap text-[#1D1F2CCC] font-[500] text-[15px]"
                          >
                            {cell}
                          </td>
                        ))
                      ) : (
                        <td
                          colSpan={
                            tableHeadings.length + (showExtraHeading ? 5 : 0)
                          }
                          className="p-3 text-center text-gray-500 whitespace-nowrap"
                        >
                          No Data Available
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="mt-4 overflow-hidden overflow-y-auto lg:hidden ">
              {data.map((row, index) => (
                <div
                  key={index}
                  className="p-4 mb-4 bg-white rounded-lg border border-[#dbdbdb]"
                >
                  {row && Array.isArray(row) && row.length > 0 ? (
                    row.map((cell, cellIndex) => (
                      <div
                        key={cellIndex}
                        className="flex items-center justify-between pb-3 mb-3 border-b border-gray-200"
                      >
                        <span className="text-xs font-medium text-gray-700">
                          {tableHeadings[cellIndex]}
                        </span>
                        <span className="text-sm font-medium">{cell}</span>
                      </div>
                    ))
                  ) : (
                    <div className="h-4 p-4 text-sm text-center text-gray-500">
                      No Data Available
                    </div>
                  )}
                </div>
              ))}
            </div>
          </>
        ) : (
          <div className="mt-2 border border-gray-300 rounded-md">
            <Nodata
              nodataLabel={"No Data found"}
              nodataDesc={"There are no Data to display"}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export const StatusCell = ({ status }) => {
  const isCompleted = status === "Completed";
  return (
    <div className="flex items-center">
      <div
        className={`w-1 h-4 mr-2 rounded-md ${
          isCompleted ? "bg-[#00811D]" : "bg-[#FFA600]"
        }`}
      ></div>
      {status}
    </div>
  );
};

export default NewTable;
